import { Button, CircularProgress } from "@mui/material";
import { useState } from "react";
import { openFileDownload } from "src/utils";

interface DownloadInternalFileProp {
  fileId: string;
}

export default function DownloadInternalFile({ fileId }: DownloadInternalFileProp) {
  const [loading, setLoading] = useState<boolean>(false);

  const handleDownload = async () => {
    setLoading(true);
    await openFileDownload(fileId, true);
    setLoading(false);
  };

  return (
    <Button
      variant="contained"
      onClick={handleDownload}
      disabled={loading}
      sx={{ backgroundColor: "#0f172a", textTransform: "none" }}
    >
      {loading ? <CircularProgress size={24} style={{ color: "white" }} /> : "Download"}
    </Button>
  );
}
